module.exports = __webpack_public_path__ + "static/img/bg-05.8b58dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/form/design/assets/bg-05.png
// module id = f5N6
// module chunks = 65